module.exports = __webpack_public_path__ + "img/touch.ddf04c60.png";